import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const EDU_STATUS = {
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  EXPIRED: 'Expired',
  APPROVED: 'Approved',
} as const;
export type EduStatus = (typeof EDU_STATUS)[keyof typeof EDU_STATUS];

export interface EduProofFile {
  url: string;
  name: string;
  type: string;
  size: number;
}

export interface EduForm {
  expectedGraduationDate: string;
  institutionName: string;
  institutionCity: string;
  institutionCountry: string;
  notes: string;
  imageProof: EduProofFile | null;
}

export interface EduState {
  form: EduForm;
  status: EduStatus | null;
  errors: Record<string, string | null>;
  submitted: boolean;
}

const initialState: EduState = {
  form: {
    expectedGraduationDate: '',
    institutionName: '',
    institutionCity: '',
    institutionCountry: '',
    notes: '',
    imageProof: null,
  },
  status: null,
  errors: {},
  submitted: false,
};

const eduSlice = createSlice({
  name: 'eduStatus',
  initialState,
  reducers: {
    setForm(state, action: PayloadAction<Partial<EduForm>>) {
      state.form = { ...state.form, ...action.payload };
    },
    setEduStatus(state, action: PayloadAction<EduStatus | null>) {
      state.status = action.payload;
    },
    setError(state, action: PayloadAction<Record<string, string | null>>) {
      state.errors = { ...state.errors, ...action.payload };
    },
    clearError(state, action: PayloadAction<string>) {
      state.errors[action.payload] = null;
    },
    setSubmitted(state, action: PayloadAction<boolean>) {
      state.submitted = action.payload;
    },
    resetEdu() {
      return initialState;
    },
  },
});

export const {
  setForm,
  setEduStatus,
  setError,
  clearError,
  setSubmitted,
  resetEdu,
} = eduSlice.actions;
export default eduSlice.reducer;
